import React, { useState } from 'react';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import objStr from 'obj-str';
import navigationService from '@/services/navigation-service';
import { Portal } from '@/components/Portal';
import { MegaMenuCategoryList } from './MegaMenuCategoryList';
import styles from './MegaMenu.module.scss';
import navigationStyles from './MainNavigation.module.scss';
import type * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

interface IMegaMenu {
  categories: Types.Category[];
}
export const MegaMenu = ({ categories }: IMegaMenu) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  navigationService.setCategories(categories);
  const rootCategories = navigationService.getRootCategories() ?? [];
  const activeCategory = rootCategories.find((category) => router.asPath.includes(category.urlSet.web));

  const openMegaMenu = () => {
    [...(document.querySelectorAll('[class^="MainNavigation"] .is-open') ?? [])].forEach((child) => child.classList.remove('is-open'));
    document.querySelector('.mega-menu-item')?.classList.add('is-open');
    setIsMenuOpen(true);
  };

  const closeMegaMenu = () => {
    setIsMenuOpen(false);
  };

  const onOverlayClose = (e: React.MouseEvent<HTMLDivElement>) => {
    //@ts-expect-error: FFS lib.dom
    if (e.pointerType === 'touch') {
      return;
    }
    closeMegaMenu();
  };

  const onMenuItemHover = (e: React.MouseEvent<HTMLLIElement>) => {
    const element = e.currentTarget;
    [...(element?.parentNode?.querySelectorAll('.is-open') ?? [])].forEach((child) => child.classList.remove('is-open'));
    element.classList.add('is-open');
  };

  return (
    <>
      <div className={styles.megaMenuContainer}>
        <a role="button" className={styles.toggleMegaMenu} onMouseEnter={openMegaMenu}>
          <span className={`text-gray-900 ${navigationStyles.navigationLink}`}>{t('common:main-navigation.Products')}</span>
          <span className={`ml-2 fa ${isMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></span>
        </a>
        <div className={`mega-menu-container ${isMenuOpen ? 'is-open' : ''}`}>
          <ul className="mega-menu">
            {rootCategories.map((rCategory, idx: number) => {
              const categories = navigationService.getChildCategoriesByParentCode(rCategory.code);
              const isActive = activeCategory ? activeCategory?.code === rCategory.code : idx === 0;

              const itemClassList = objStr({
                'mega-menu-item': true,
                'is-open': isActive,
                'is-active': isActive
              });

              return (
                <li className={itemClassList} key={rCategory.code} onMouseEnter={onMenuItemHover}>
                  <a className="level-0 has-submenu d-none d-lg-inline-flex" href={rCategory.urlSet.web} role="button">
                    {rCategory.name}
                  </a>
                  <div className={`menu-item-pane ${styles.menuItemPane}`}>
                    <MegaMenuCategoryList categories={categories} />
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      {isMenuOpen && (
        <Portal selector="#navigation">
          <div className={styles.navOverlay} onMouseEnter={onOverlayClose}></div>
        </Portal>
      )}
    </>
  );
};
